import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { fetchCsrfToken, waitForCsrfToken } from "@/utils/useFetch";

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_API_URL || "",
  credentials: "include",
  prepareHeaders: (headers) => {
    const csrfToken = sessionStorage.getItem("csrfToken");
    if (csrfToken) {
      headers.set("x-csrf-token", csrfToken);
    }
    return headers;
  },
});

const baseQueryWithCsrfRetry = async (args, api, extraOptions) => {
  await waitForCsrfToken();
  let result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 403 && result.error?.data?.status_message?.toLowerCase().includes("csrf token")) {
    await fetchCsrfToken();
    result = await baseQuery(args, api, extraOptions);
  }
  return result;
};

export const lenderApi = createApi({
  reducerPath: "lenderApi",
  baseQuery: baseQueryWithCsrfRetry,
  tagTypes: ["commercial", "consumer", "personal", "business"],
  endpoints: (builder) => ({
    getCommercialLenders: builder.query({
      query: () => ({
        url: "/lender",
        method: "POST",
        body: { type: "commercial" },
      }),
      providesTags: ["commercial"],
    }),
    getBusinessLenders: builder.query({
      query: () => ({
        url: "/lender",
        method: "POST",
        body: { type: "business" },
      }),
      providesTags: ["business"],
    }),
    getConsumerLenders: builder.query({
      query: () => ({
        url: "/lender",
        method: "POST",
        body: { type: "consumer" },
      }),
      providesTags: ["consumer"],
    }),
    getPersonalLenders: builder.query({
      query: () => ({
        url: "/lender",
        method: "POST",
        body: { type: "personal" },
      }),
      providesTags: ["personal"],
    }),
    getAllLenders: builder.query({
      query: () => ({
        url: "/lender",
        method: "POST",
        body: { limit: 10 },
      }),
    }),
  }),
});

export const {
  useGetCommercialLendersQuery,
  useGetBusinessLendersQuery,
  useGetConsumerLendersQuery,
  useGetPersonalLendersQuery,
  useGetAllLendersQuery,
} = lenderApi;
